import { axiosInstance } from 'shared/api';
import { getGenerationsUrl } from 'shared/api/config/api.config';

import { TGenerations } from './types/generations.types';

export const GenerationsService = {
  async startGenerations(data: TGenerations.startGenerations) {
    const response = await axiosInstance.post(getGenerationsUrl('/start-generations'), {
      params: data
    });

    return response;
  },
  async checkIsGeneration() {
    const response = await axiosInstance.get<TGenerations.checkIsGenerationResponse>(
      getGenerationsUrl('/check-generations')
    );

    return response;
  },
  async stopGenerations() {
    const response = await axiosInstance.post(getGenerationsUrl('/start-generations'));

    return response;
  }
};
